import axios from "axios";
import React from "react";
import { useDispatch } from "react-redux";
import { emailVerification } from "../../../redux/actions/user/UserActions";

function RegisterConfirmation(props: any) {
  const dispatch = useDispatch();
  if (props.match.path === "/user-register-confirmation/:confirmationKey") {
    dispatch(emailVerification(props));
  }
  return (
    <>
      <div className="container py-2" id="registerConfirmationContainer"> 
        <div className="row py-5">
          <div className="col-lg-8" style={{ textAlign: "left" }}>
            <h1 className="display-4 " style={{ color: "green" }}>
              Account Verified
            </h1>
            <hr></hr>
            <p className="lead text-muted mb-0">
              <strong>
                Congratulations!! Your identification has been reviewed and
                verified successfully.
              </strong>
            </p>
            <p className="lead text-underlined mb-0">
              Now you can continue to the our application for exploring the
              political stakeholders and reviewing them.
            </p>
            <p className="lead text-underlined mb-0">
              Thanks for helping us maintain a trusted political review system
              for all.
            </p>
            {/* <hr></hr> */}
            <p className="lead text-underlined  mb-0">
              <a
                className="btn btn-success"
                href="/user-login"
                style={{
                  background: "dodgerblue",
                  marginTop: "15px",
                  marginBottom: "15px",
                  border: "none",
                }}
              >
                Continue to Login
              </a>
            </p>
            {/* <hr></hr> */}
          </div>
          <div className="col-lg-4 d-none d-lg-block">
            <img src="/verified.jpg" alt="Verified" className="img-fluid" />
          </div>
          <div
            className="container align-items-center"
            style={{ textAlign: "center" }}
          >
            {/* <hr></hr> */}
            <p className="lead">
              <strong>
                If you need any kind of assistance while using the system, feel
                free to
                <a href="/contact-us" style={{ color: "dodgerblue" }}>
                  {" "}
                  contact us
                </a>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterConfirmation;
